import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import MenuBarComponent from '../MenuBar/MenuBarComponent';
import DashboardComponent from '../Dashboard/DashboardComponent';
import { connect } from 'react-redux';
import { fetchDetails } from '../../actions/index';
import * as dashboardActions from '../../actions/dashboardActions';
import * as CommonActions from '../../actions/commonActions';
import * as authAction from '../../redux/modules/auth';
import * as activityActions from '../../actions/activityActions';
import * as reportActions from '../../actions/reportActions';
import {themes} from "../../theme/styles/themeJS";
import track from 'react-tracking';

var errorLogInterval;

let version;
let wsStatus =''
let wsType = ''
let wsMessage = {}

@track((props, state) => ({ widgetDetails: { page: "Home", eventType: props.userDetail.isTrdInstant === '1' ? 'Single Click' : 'Double Click'}}))

class Home extends Component {
  state = {
    currentTheme:''
  }
  constructor(props) {
    super(props);
    this.closeOnRefresh = this.closeOnRefresh.bind(this);
    this.onBackButtonEvent = this.onBackButtonEvent.bind(this);
    window.onbeforeunload = this.logoutOnClose.bind(this);
  }

  onBackButtonEvent = (e) => {
    try{
      e.preventDefault();
      localStorage.setItem('backButtonFlag', 'true');
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        this.props.logout(this.props.userDetail);
        this.props.history.push("/backbutton")
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'onBackButtonEvent', component:"Home"});
    }
  }

  componentWillMount() {
    var user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      // store.dispatch is not required 
      this.props.fetchDetails();
    }
    version = localStorage.getItem('ver');
    // To prevent home page opening on another tab if already logged in.
    if (version === null) {
      if (localStorage.getItem('backButtonFlag') !== 'true') {
        // return <Redirect to="/session_expired" />
      } else {
        this.props.logout(this.props.userDetail);
        this.props.history.push("/backbutton")
      }
    }
  }

  componentDidMount() {
    this.props.changeResetPasswordStatus()
    localStorage.removeItem('ver');
    window.addEventListener('beforeunload', this.closeOnRefresh);
    window.addEventListener('popstate', this.onBackButtonEvent);
    errorLogInterval = setInterval(() => {
      if(this.props.errorLogs.length !==0){
        this.props.sendErrorLogs(this.props.errorLogs)
      }
    }, 120000);
    if(this.props.userDetail !== null){
      this.setTheme(this.props.userDetail.selectedTheme);
    }
  }

  componentWillReceiveProps(nextProps,nextState){
    if (this.state.currentTheme !== nextProps.userDetail.selectedTheme) { 
      this.setState({currentTheme:nextProps.userDetail.selectedTheme})
      this.setTheme(nextProps.userDetail.selectedTheme);
    }
    if(nextProps.rateWSStatus && this.props.rateWSStatus !== nextProps.rateWSStatus){
      this.captureWSStatus(nextProps.rateWSStatus,'rate');
    }
    if(nextProps.orderWSStatus && this.props.orderWSStatus !== nextProps.orderWSStatus){
      this.captureWSStatus(nextProps.orderWSStatus,'order');
    }
    if(nextProps.wsRandomNo !== this.props.wsRandomNo){
      if(nextProps.wsMessage){
        this.captureWSMessage(nextProps.wsMessage)
      }
    }
  }

  componentWillUnmount() {
    const { handler } = this.props;
    clearInterval(errorLogInterval);
    if (handler) {
      for (let currWindow = 0; currWindow < handler.length; currWindow++) {
        handler[currWindow].close();
      }
    }
    // if(this.props.orderWSStatus === null && this.props.rateWSStatus === null){
    //   this.captureWSStatus('disconnected','order');
    //   this.captureWSStatus('disconnected','rate');
    // }
    this.props.resetState();
    this.props.loadTemplateFlag(false);
    this.props.resetStateReport();
    this.props.isAllApiLoaded(false);
    window.removeEventListener('beforeunload', this.closeOnRefresh);
    this.setState({currentTheme:''})
  }

  @track((props) => ({
    wsDetails:[{WS: wsType, Status: wsStatus}],
    user : {SID: props.userDetail.SID, UD: props.userDetail.UD, UID: props.userDetail.UID} //passing user details for ws disconnection scenario on kill session
  }))

  captureWSStatus = (status, type) =>{
    try{
      wsStatus = status
      wsType = type
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'captureWSStatus', component:"Home"});
    }
  }

  @track(() => ({
    wsResponse: wsMessage
  }))

  captureWSMessage = (message) => {
    wsMessage = message
  }

  // Logout when browser window closes
  logoutOnClose() {
    try{
      const { handler } = this.props;
      if (handler) {
        for (let currWindow = 0; currWindow < handler.length; currWindow++) {
          handler[currWindow].close();
        }
      }
      this.props.logout(this.props.userDetail);
      localStorage.setItem('userlogin', null);
      this.props.loadTemplateFlag(false);
      this.props.resetState();
      this.props.resetStateReport();
      this.props.isAllApiLoaded(false);
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'logoutOnClose', component:"Home"});
    }
  }

  // Logout on refresh
  closeOnRefresh() {
    try{
      localStorage.setItem('userlogin', null);
      localStorage.setItem('user', null);
      localStorage.setItem('userDetail', null);
      this.props.resetState();
      this.props.resetStateReport();
      this.props.loadTemplateFlag(false);
      this.props.isAllApiLoaded(false);
      this.props.editDashboard(false);
      const { handler } = this.props;
      if (handler) {
        for (let currWindow = 0; currWindow < handler.length; currWindow++) {
          handler[currWindow].close();
        }
      }
      this.props.setLogoutFlag(false);
      if (this.props.userDetail !== null) {
        this.props.logout(this.props.userDetail);
      }
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeOnRefresh', component:"Home"});
    }
  }

  closeModal = () => {
    try{
      this.props.handleSession();
      this.props.hidePopup();
      localStorage.setItem('user', null);
      return <Redirect to="/login" />
    }catch(e){
      this.props.logFileCreation({error:e.message, originFunction:'closeModal', component:"Home"});
    }
  }
/*---- theme chnges */
setTheme = (newTheme) => { 
  try{
    const theme = themes[newTheme];
    Object.keys(theme).forEach((key => {
      const cssKey = `--${key}`;
      const cssValue = theme[key];
      document.body.style.setProperty(cssKey, cssValue);
    }))
  }catch(e){
    this.props.logFileCreation({error:e.message, originFunction:'setTheme', component:"Home"});
  }
}
  render() {
    var user = JSON.parse(localStorage.getItem('user'));
    if (this.props.sessionTimeOut === true && version === null) {
      return <Redirect to="/login" />
    }
    if (this.props.logoutSuccess === true) {
      return <Redirect to="/login" />
    }
    if (!this.props.logoutSuccess && this.props.isInitialApiLoaded) {
      return (
        <div>
          {this.props.sessionTimeOut === true || user === null ? null : <div>
            <MenuBarComponent props={this.props.language} />
            <DashboardComponent props={this.props.language} />
          </div>}
        </div>
      );
    }
    else {
      return (
        <div>
          <div className="loginLoader">
            <img src="/images/loader.gif" />
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    sessionTimeOut: state.dashboardRoot.dashboardReducer.sessionTimeOut,
    showPopup: state.dashboardRoot.dashboardReducer.showPopup,
    handler: state.dashboardRoot.commonReducer.handler,
    isInitialApiLoaded: state.dashboardRoot.dashboardReducer.isInitialApiLoaded,
    user: state.auth.user,
    userDetail: state.auth.userDetail,
    logoutSuccess: state.auth.logoutSuccess,
    language: state.dashboardRoot.commonReducer.language,
    allCssColorThemeData: state.dashboardRoot.commonReducer.allCssColorThemeData,
    selectedTheme: state.auth.selectedTheme,
    errorLogs: state.dashboardRoot.commonReducer.errorLogs,
    rateWSStatus:state.dashboardRoot.instrumentListReducer.wsStatus,
    orderWSStatus:state.dashboardRoot.tradepanelReducer.wsStatus,
    wsRandomNo:state.dashboardRoot.tradepanelReducer.wsRandomNo,
    wsMessage:state.dashboardRoot.tradepanelReducer.wsMessage,
  };
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchDetails: fetchDetails,
    logout: authAction.logout,
    hidePopup: dashboardActions.hidePopup,
    handleSession: authAction.handleSession,
    editDashboard: dashboardActions.editDashboard,
    loadTemplateFlag: dashboardActions.loadTemplateFlag,
    resetState: activityActions.resetState,
    resetStateReport: reportActions.resetStateReport,
    setLogoutFlag: dashboardActions.setLogoutFlag,
    isAllApiLoaded: dashboardActions.isAllApiLoaded,
    changeResetPasswordStatus: authAction.changeResetPasswordStatus,
    sendErrorLogs: CommonActions.sendErrorLogs,
    logFileCreation: CommonActions.logFileCreation
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);
